import { useState, useEffect } from 'react'
import { CAL_START_HOUR, CAL_END_HOUR, HOUR_HEIGHT } from './calendarConstants'

/** Returns current time offset in pixels from the top of the time grid, or null if outside range */
export function useCurrentTimeLine(): number | null {
  const [topPx, setTopPx] = useState<number | null>(null)

  function calc() {
    const now = new Date()
    const hourDecimal = now.getHours() + now.getMinutes() / 60
    if (hourDecimal < CAL_START_HOUR || hourDecimal > CAL_END_HOUR) {
      setTopPx(null)
      return
    }
    setTopPx((hourDecimal - CAL_START_HOUR) * HOUR_HEIGHT)
  }

  useEffect(() => {
    calc()
    const interval = setInterval(calc, 60_000)
    return () => clearInterval(interval)
  }, [])

  return topPx
}
